import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { HerocarouselComponent } from './herocarousel/herocarousel.component';
import { CategoryCarouselComponent } from './category-carousel/category-carousel.component';
import { CarouselimageComponent } from './carouselimage/carouselimage.component';



@NgModule({
  declarations: [
    HomeComponent,
    HerocarouselComponent,
    CategoryCarouselComponent,
    CarouselimageComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HomeComponent
  ]
})
export class HomeModule { }
